import api from "@/api/changeTariff";
import Vue from "vue";

const defaultSections = ()=>({
  reason: {},
  tariff: {
    tariff: {},
    length: {},
    promo: {},
    previous: {
      tariff: {},
      length: {},
      promo: {},
    }
  },
  addons: {
    addons: [],
    previous: [],
    unavailable: [],
  },
  lineFeatures: {
    addons: [],
    previous: [],
  },
  adhocCharges: {},
  confirm: false,
});

const state = () => ({
  currentStep: 1,
  totals: {
    previous: {name: 'Previous Total', total: 0.00},
    promo: {name: 'Monthly price in promo exc. VAT', total: 0.00},
    vat: {name: 'Monthly VAT', total: 0.00},
    total: {name: 'Total monthly price', total: 0.00},
    adhoc: {name: 'Ad Hoc Charges excl. VAT', total: 0.00},
  },
  productKind: '',
  product: {},
  sections: defaultSections(),
  changeReasons: {
    telco: [
      { 
        text: 'Contract Renewal', 
        value: 'CONTRACT_RENEWALS', 
        permissions: ['can-do-contract-renewals'],
        tooltip: { 
          permission: 'You do not have permission to use the Contract Renewals change reason' 
        }
      },
      { 
        text: 'Retention', 
        value: 'RETENTION', 
        permissions: ['can-use-retention-change-tariff'],
        tooltip: { 
          permission: 'You do not have permission to use the Retention change reason' 
        }
      },
      {text: 'Change Add Ons', value: 'CHANGE_ADDON'},
      {text: 'Change Product', value: 'CHANGE_PRODUCT'},
    ],
    telcoWithPre: [
      {text: 'Pre-live', value: 'PRE_LIVE'},
    ],
  },

  tariffs: [],
  tariffsLoading: false,
  tariffsError: null,

  changeTariff: [],
  changeTariffLoading: false,
  changeTariffError: null,

  addonsLoading: false,
  addonsError: null,
});

const mutations = {
  set_productKind: (state,kind) => { state.productKind = kind; },
  set_changeTariffProduct: (state,product) => { state.product = product;},
  set_activeSections: (state,sections) => { state.activeSections = sections; },
  set_stepNext: (state) => { state.currentStep = state.currentStep+1; },
  set_stepPrev: (state) => { state.currentStep = state.currentStep-1; },
  
  set_section: (state,data) => {
    if(typeof data.section === 'object'){
      state.sections[data.section[0]][data.section[1]] = data.value;
    }else{
      state.sections[data.section] = data.value;
    }
  },
  
  set_previous_tariffs: (state,product) => {
    const tariff = mapTariffs(state.tariffs.filter(e=>e.id===product.tariff_id));
    Vue.set(state.sections.tariff.previous, 'tariff', tariff[0]);
    Vue.set(state.sections.tariff, 'tariff', tariff[0]);
    
    const length = {
      text: product.contract_length_months===1 ? `Month to Month` : `${product.contract_length_months} Months`,
      value: product.contract_length_months
    };
    state.sections.tariff.previous.length = length;
    state.sections.tariff.length = length;
    
    const promo = mapPromos(tariff[0].promos.filter(pro=>pro.promo.id===product.promo_id));
    state.sections.tariff.previous.promo = promo[0];
    state.sections.tariff.promo = promo[0];
  },
  fetch_tariffs_begin: (state) => { state.tariffsLoading = true; },
  fetch_tariffs_success: (state,data) => {
    state.tariffs = data;
    state.tariffsLoading = false;
  },
  fetch_tariffs_failed: (state,data) => {
    state.tariffsError = data;
    state.tariffsLoading = false;
  },

  post_change_tariff_begin: (state) => { state.changeTariffLoading = true; },
  post_change_tariff_success: (state,data) => {
    state.changeTariff = data;
    state.changeTariffLoading = false;
  },
  post_change_tariff_failed: (state,data) => {
    state.changeTariffError = data;
    state.changeTariffLoading = false;
  },
  
  fetch_addons_begin: (state) => { state.addonsLoading = true; },
  fetch_addons_success: (state,data) => {
    state.sections.addons = mapAddons(data.data,data.product);
    state.sections.lineFeatures = mapLineFeatures(data.data,data.product);
    state.addonsLoading = false;
  },
  fetch_addons_failed: (state,data) => {
    state.addonsError = data;
    state.addonsLoading = false;
  },

  reset_section_tariff: (state) => {
    state.sections.tariff = {
        tariff: {},
        length: {},
        promo: {},
        previous: {
          tariff: {},
          length: {},
          promo: {},
        }
    };
  },

  reset_changeTariff: (state) => {
    state.currentStep = 1;
    state.sections = defaultSections();
  },
};

const actions = {
  async fetchTariffs({state,commit},product){
    commit('fetch_tariffs_begin');
    try{
      let res = {};
      if(state.productKind==='telco'){ res = await api.fetchTelcoTariffs(); }

      if(res.status===200){
        commit('fetch_tariffs_success',res.data);
        commit('set_previous_tariffs',product);
      }else{
        commit('fetch_tariffs_failed',res.data);
      }

    }catch(err){
      commit('fetch_tariffs_failed',err.response.data.message);
    }
  },

  async fetchAddons({state,commit},product){
    commit('fetch_addons_begin');
    try{
      let res = {};
      if(state.productKind==='telco'){ res = await api.fetchTelcoAddons(); }
      if(res.status===200){
        commit('fetch_addons_success',{data:res.data,product});
      }else{
        commit('fetch_addons_failed',res.data);
      }

    }catch(err){
      commit('fetch_addons_failed',err.response.data.message);
    }
  },

  async postChangeTariff({state,commit,dispatch},data){
    commit('post_change_tariff_begin');
    try{
      let res = {};
      if(state.productKind==='telco'){ res = await api.postChangeTariff(data); }
      if(res.status===200){
        commit('post_change_tariff_success',res.data);
        dispatch("alerts/setAlert", {type: "success",message: 'Change tariff successfull!'}, { root: true });
      }else{
        commit('post_change_tariff_failed',res.data);
        dispatch("alerts/setAlert", {type: "error",message: res.data.message}, { root: true });
      }
      
    }catch(err){
      commit('post_change_tariff_failed',err.response.data.message);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
};

const mapRequiredCharges = (charges)=>{
  if(!charges){ return []; }
  return charges.map(e=>({
    id: e.id,
    name: e.name,
    price: e.standard_price,
    allowQuantity: false,
    quantity: false,
    checked: true,
    selectError: false,
    group: false,
    state: {text:'unchanged',color:''},
    category: e.category,
  }));
}

const mapTariffs = (tariffs)=>{
  return tariffs.map(e=>({
    text: e.name,
    value: e.id,
    length: e.min_contract_length_months,
    promos: e.promos,
    price: e.standard_price,
    adhocCharges: mapRequiredCharges(e.required_charges),
    service: e.service,
    category: e.category,
  }));
}

const mapPromos = (promos)=>{
  return promos.map(pro=>({
    text: pro.promo.name,
    value: pro.promo.id,
    price: pro.promo.price,
    charges: mapRequiredCharges(pro.promo.required_charges),
  }));
}

const lengths = (length)=>{
  const lengths = [1,12,18,24,36,48].splice([1,12,18,24,36,48].indexOf(length));
  return lengths.map(len=>({
    text: len===1 ? `Month to Month` : `${len} Months`,
    value: len,
  }));
}

const titleCase = (string)=>{
  return string.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

const replaceGroupName = (name)=>{
  return name.split('_').map(sec=>sec==='bonline'?sec.replace(/(bonline)/g,'bOnline'):titleCase(sec)).join(' ');
}

const mapIndividualAddons = (addons,previousAddons)=>{
  return addons.map(e=>({
    id: e.id,
    name: e.name,
    price: e.standard_price,
    allowQuantity: e.allow_quantity,
    quantity: e.allow_quantity,
    checked: previousAddons.includes(e.id),
    selectError: false,
    group: false,
    available: e.available,
  }));
}
  
const mapAddons = (addons,product)=>{
  const previousAddons = product.addons.map(e=>e.addon_id);
  
  const groups = [...new Set(addons.filter(e=>
    e.available && 
    e.display_group && 
    e.category!=='cnf_service'
  ).map(e=>e.display_group))];
  
  const groupedAddons = addons.filter(e=>groups.includes(e.display_group));
  
  const groupedItems = groups.map(g=>{
    const currentAddons = mapIndividualAddons(groupedAddons.filter(a=>
      previousAddons.includes(a.id) && 
      a.display_group===g
    ),previousAddons);

    return {
      name: replaceGroupName(g),
      group: true,
      selected: currentAddons[0] && currentAddons[0].available ? currentAddons[0] : {},
      checked: currentAddons[0] && currentAddons[0].available ? true : false,
      options: mapIndividualAddons(groupedAddons.filter(a=>
        a.available && 
        a.display_group===g
      ),previousAddons),
      selectError: false,
      available: g.available
    }
  }).filter(group=>group.options.length);

  const singleItems = mapIndividualAddons(addons.filter(e=>
    e.available && 
    !groups.includes(e.display_group) && 
    e.category!=='cnf_service'
  ),previousAddons);

  const unavailableAddons = mapIndividualAddons(addons.filter(e=>!e.available && e.category!=='cnf_service'),previousAddons).filter(e=>product.addons.some(a=>a.addon_id === e.id));

  return {
    addons: groupedItems.concat(singleItems),
    previous: previousAddons,
    unavailable: unavailableAddons,
  };
}

const mapLineFeatures = (addons,product)=>{
  const previousAddons = product.addons.map(e=>e.addon_id);
  const unavailableAddons = mapIndividualAddons(addons.filter(e=>!e.available && e.category==='cnf_service'),previousAddons).filter(e=>product.addons.some(a=>a.addon_id === e.id));

  return {
    addons: mapIndividualAddons(addons.filter(e=>e.available && e.category==='cnf_service'),previousAddons),
    previous: previousAddons,
    unavailable: unavailableAddons,
  };
}

const totalAddons = (addons)=>{
  if(!addons){ return 0; }
  return addons.reduce((total,charge)=>{
    return total += charge.price ? parseFloat(charge.price) : 0;
  },0);
}

const totalAdhoc = (adhocs)=>{
  if(!adhocs){ return 0; }
  return adhocs.reduce((total,charge)=>{
    return total += charge.price ? parseFloat(charge.price) : 0;
  },0);
}

const getters = {
  getTotals: (state,getters) => {

    let prevTotal = 0;
    let currentTotal = 0;
    const vatAmount = 0.2;

    const prevTariff = state.sections.tariff.previous.tariff;
    const prevPromo = state.sections.tariff.previous.promo ? state.sections.tariff.previous.promo : {};
    const prevAddons = totalAddons(getters.getPreviousAddons('addons'));
    const prevLineFeatures = totalAddons(getters.getPreviousAddons('lineFeatures'));
    const prevAdhoc = prevPromo&&prevPromo.value ? totalAdhoc(prevPromo.charges) : totalAdhoc(prevTariff.adhocCharges);

    const currentTariff = state.sections.tariff.tariff;
    const currentPromo = state.sections.tariff.promo;
    const currentAddons = totalAddons(getters.getCurrentAddons('addons'));
    const currentLineFeatures = totalAddons(getters.getCurrentAddons('lineFeatures'));
    const currentAdhoc = currentPromo&&currentPromo.value ? totalAdhoc(currentPromo.charges) : totalAdhoc(currentTariff.adhocCharges);

    prevTotal += prevPromo&&prevPromo.value ? 
      parseFloat(prevPromo.price) + prevAddons + prevLineFeatures: 
      parseFloat(prevTariff.price) + prevAddons + prevLineFeatures;

    currentTotal += currentPromo&&currentPromo.value ? 
      parseFloat(currentPromo.price) + currentAddons + currentLineFeatures: 
      parseFloat(currentTariff.price) + currentAddons + currentLineFeatures;

    state.totals = {
      previous: {name: 'Previous Total', total: (prevTotal * (1+vatAmount)) ? prevTotal * (1+vatAmount) : 0},
      promo: {name: 'Monthly price exc. VAT', total: (currentTotal) ? currentTotal : 0},
      vat: {name: 'Monthly VAT', total: (currentTotal * vatAmount) ? currentTotal * vatAmount : 0},
      total: {name: 'Total monthly price', total: (currentTotal * (1+vatAmount)) ? currentTotal * (1+vatAmount) : 0},
      adhoc: {name: 'Ad Hoc Charges excl. VAT', total: currentAdhoc && getters.getAdhocCharges.length > 0 ? currentAdhoc : 0},
    };

    return Object.keys(state.totals).map(key=>({
      ...state.totals[key],
      id: key
    }));
  },
  getCurrentStep: state => state.currentStep,
  getChangeReasons: state => confirmedDate => {
    return confirmedDate ? state.changeReasons[state.productKind] : state.changeReasons.telcoWithPre;
  },
  getChangeReason: state => state.sections.reason,
  getAllSections: (state,getters)  => product => ({
    adhoc_charges: getters.getAdhocCharges.map(e=>({charge_credit_id: e.id, quantity: 1})),
    change_reason: state.sections.reason.value,
    product: {
      addons: getters.getCurrentAddons('addons').concat(getters.getCurrentAddons('lineFeatures')).map(e=>({
        addon_id: e.id,
        quantity: 1
      })),
      contract_length_months: state.sections.tariff.length.value,
      id: product.id,
      promo_id: state.sections.tariff.promo && state.sections.tariff.promo.value ? state.sections.tariff.promo.value : null,
      tariff_id: state.sections.tariff.tariff.value
    }
  }),
  getSection: state => section => state.sections[section],
  getProductKind: state => state.productKind,

  getIsNewContract: state => ['CONTRACT_RENEWALS','CHANGE_PRODUCT','LINE_RESTART','RETENTION','OTHERS'].includes(state.sections.reason.value),

  getTariffs: state => {
    const tariffs = mapTariffs(state.tariffs.filter(e=>e.available));
    const prevTariff = state.sections.tariff.previous;
    const reason = state.sections.reason;
    if(Object.keys(prevTariff).length && prevTariff.tariff && prevTariff.tariff.value && Object.keys(reason).length && !['PRE_LIVE', 'CHANGE_PRODUCT'].includes(reason.value)) {
      return tariffs.filter(tariff => tariff.service === prevTariff.tariff.service);
    }
    return tariffs;
  },
  getTariffLengths: state => lengths(state.sections.tariff.tariff.length),
  getTariffPromos: state => {
    if(!state.sections.tariff.tariff.promos){ return []; }
    const length = state.sections.tariff.length.value;
    const promos = mapPromos(state.sections.tariff.tariff.promos.filter(pro=>
      pro.available && pro.promo.min_contract_length_months<=length
    ));
    
    return [{text:'No promo',value:null}].concat(promos);
    },
  getTariffsLoading: state => state.tariffsLoading,
  getTariffsError: state => state.tariffsError,

  getChangeTariff: state => state.changeTariff,
  getChangeTariffLoading: state => state.changeTariffLoading,
  getChangeTariffError: state => state.changeTariffError,

  getIsTariffChanged: state => state.sections.tariff.tariff.value!==state.sections.tariff.previous.tariff.value,
  getIsLengthChanged: state => state.sections.tariff.length.value!==state.sections.tariff.previous.length.value,
  getIsPromoChanged: state => {
    if(!state.sections.tariff.previous.promo&&state.sections.tariff.promo&&state.sections.tariff.promo.value){ return true; }
    return (state.sections.tariff.promo&&state.sections.tariff.previous.promo) ? state.sections.tariff.promo.value!==state.sections.tariff.previous.promo.value : false;
  },
  getIsAnyTariffChanged: (state,getters) => getters.getIsTariffChanged || getters.getIsLengthChanged || getters.getIsPromoChanged,
  
  getAddons: state => state.sections.addons.addons,
  getLineFeatures: state => state.sections.lineFeatures.addons,
  getAddonsLoading: state => state.addonsLoading,
  getAddonsError: state => state.addonsError,

  getPreviousAddons: (state,getters) => type => {
    const previousAddons = type==='addons' ? state.sections.addons.previous : state.sections.lineFeatures.previous;
    const addons = type==='addons' ? getters.getAddons : getters.getLineFeatures;
    return addons.map(e=>{
      if(e.group){
        const options = e.options.filter(a=>previousAddons.includes(a.id));
        if(options.length){
          return options[0];
        }
      }else if(previousAddons.includes(e.id)){
        return e;
      }
    }).filter(e=>e);
  },

  getCurrentAddons: (state,getters) => type => {
    const addons = type==='addons' ? getters.getAddons : getters.getLineFeatures;
    return addons.filter(e=>e.checked).map(e=>{
      return e.group ? e.selected : e;
    }).filter(e=>e);
  },

  getUnavailableAddons: (state) => type => {
    const addons = type==='addons' ? state.sections.addons.unavailable : state.sections.lineFeatures.unavailable;
    return addons;
  },

  getAddonsView: (state,getters) => type => {
    const previousAddons = getters.getPreviousAddons(type);
    const currentAddons = getters.getCurrentAddons(type);

    const sameAddons = currentAddons.filter(e => e.available).map(e=>({
      ...e, state: previousAddons.map(p=>p.id).includes(e.id) ? {text:'unchanged',color:''}: {text:'added',color:'secondary--text'}
    }));

    const removedAddons = previousAddons.filter(e=>e.available&&!currentAddons.map(c=>c.id).includes(e.id)).map(e=>({
      ...e, state: {text:'removed',color:'error--text'}
    }));

    const unavailableAddons = getters.getUnavailableAddons(type).map(e => ({ 
      ...e, state: {text:'unavailable',color:'error--text'}
    }));

    return sameAddons.concat(removedAddons).concat(unavailableAddons);
  },

  getAdhocCharges: (state,getters) => {
    let charges = [];
    if (getters.isPreLiveProduct) {
      return charges;
    }

    const tariffCharges = state.sections.tariff.tariff.adhocCharges;
    const promo = state.sections.tariff.promo || {};
    const promoCharges = promo.charges || [];

    const previousPromoCharges = (state.sections.tariff.previous.promo&&state.sections.tariff.previous.promo.charges) ? state.sections.tariff.previous.promo.charges.map(e=>e.id) : [];
    const previousTariffCharges = (state.sections.tariff.previous.tariff&&state.sections.tariff.previous.tariff.adhocCharges) ? state.sections.tariff.previous.tariff.adhocCharges.map(e=>e.id) : [];

    const reason = state.sections.reason;

    if(promoCharges.length){
      charges = promoCharges.map(e=>({
        ...e,
        state: previousPromoCharges.includes(e.id) ? e.state : {text:'added',color:'secondary--text'}
      }));
    }else if(tariffCharges && tariffCharges.length){
      charges = tariffCharges.map(e=>({
        ...e,
        state: previousTariffCharges.includes(e.id) ? e.state : {text:'added',color:'secondary--text'}
      }));
    }

    return charges.filter(e=>{
      if(Object.keys(reason).length && !['CHANGE_PRODUCT'].includes(reason.value)) {
        return !['broadband_activation'].includes(e.category);
      }
      return e;
    });
  },
  isPreLiveProduct: (state) => {
    return !state.product.confirmed_date;
  },
  getAdhocChargesTotal: (state,getters) => {
    return getters.getAdhocCharges.reduce((acc,charge)=>acc + parseFloat(charge.price),0);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
